import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const DonutPanel = ({ title, unit, centerValue, centerLabel, donutData, donutOptions, legendItems, dotColor, delay }) => {
  const gridPositions = ['dp1', 'dp2', 'dp3'];
  const index = ['Energy Mix', 'Water Split', 'Waste Types'].indexOf(title);

  const tagStyles = {
    'Energy Mix': { background: '#dcfce7', color: '#15803d' },
    'Water Split': { background: '#dbeafe', color: '#1d4ed8' },
    'Waste Types': { background: '#ffe4e6', color: '#be123c' },
  };

  const centerColors = {
    'Energy Mix': '#16a34a',
    'Water Split': '#2563eb',
    'Waste Types': '#e11d48',
  };

  return (
    <div className={`panel ${gridPositions[index]}`} style={{ animationDelay: delay }}>
      <div className="ph">
        <div className="pt">
          <div className="pdot" style={{ background: dotColor, boxShadow: `0 0 0 2px ${dotColor}33` }}></div>
          {title}
        </div>
        <div className="ptag" style={tagStyles[title]}>{unit}</div>
      </div>
      <div className="donut-body">
        <div className="dbox">
          <Doughnut data={donutData} options={donutOptions} />
          <div className="dcc">
            <div className="dcc-n" style={{ color: centerColors[title] }}>{centerValue}</div>
            <div className="dcc-l">{centerLabel}</div>
          </div>
        </div>
        <div className="dleg">
          {legendItems.map((item, idx) => (
            <div key={idx} className="dli">
              <div className="dli-l">
                <div className="dli-pip" style={{ background: item.color }}></div>
                {item.label}
              </div>
              <div className="dli-v">{item.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DonutPanel;
